import { immer } from "zustand/middleware/immer";
import { create } from "zustand";

export type SceneMetric = "vis" | "pop" | "soa" | "pow";

/* Store Types */
interface ReportsSceneState {
  metric: SceneMetric;
  showCopilot: boolean;
  setMetric: (metric: SceneMetric) => void;
  setShowCopilot: (show: boolean) => void;
}

/*
 * Reports Scene Store
 *
 * This store is used to manage the metric filter for the scene report pages.
 * The metric value directly corresponds to the API's orderBy parameter.
 */
export const useReportsSceneStore = create<ReportsSceneState>()(
  immer((set) => ({
    metric: "vis",
    showCopilot: false,

    /* Actions */
    setMetric: (metric) =>
      set((state) => {
        state.metric = metric;
      }),
    setShowCopilot: (show) =>
      set((state) => {
        state.showCopilot = show;
      }),
  })),
);
